const S3_BUCKET_NAME =
    process.env.NODE_ENV === 'production'
        ? (window as any)._env_.REACT_APP_S3_BUCKET_NAME
        : process.env.REACT_APP_S3_BUCKET_NAME
        ? process.env.REACT_APP_S3_BUCKET_NAME
        : '';

const S3_REGION =
    process.env.NODE_ENV === 'production'
        ? (window as any)._env_.REACT_APP_S3_REGION
            ? '.s3.' + (window as any)._env_.REACT_APP_S3_REGION
            : process.env.REACT_APP_S3_REGION
            ? '.s3.' + process.env.REACT_APP_S3_REGION
            : '.s3'
        : '.s3';

export const constants = {
    BASE_URL:
        process.env.NODE_ENV === 'production'
            ? (window as any)._env_.REACT_APP_APIPY
            : process.env.REACT_APP_APIPY || 'http://localhost:8000',

    BASE_IMAGE_URL: 'https://' + S3_BUCKET_NAME + S3_REGION + '.amazonaws.com/images/',

    E_GIFT_CARD_URL:
        process.env.NODE_ENV === 'production'
            ? (window as any)._env_.REACT_APP_EGIFTCARD_WEB_URL
            : process.env.REACT_APP_EGIFTCARD_WEB_URL,

    MERCHANT_URL:
        process.env.NODE_ENV === 'production'
            ? (window as any)._env_.REACT_APP_MERCHANT_URL
            : process.env.REACT_APP_MERCHANT_URL,

    USE_NOW_URL:
        process.env.NODE_ENV === 'production'
            ? (window as any)._env_.REACT_APP_USE_NOW_URL
            : process.env.REACT_APP_USE_NOW_URL,

    API_STYLES_PATH: 'https://' + S3_BUCKET_NAME + S3_REGION + '.amazonaws.com/styles/',

    // if basename is not defined then basename will default to root
    SH_PORTAL_BASENAME:
        process.env.NODE_ENV === 'production'
            ? (window as any)._env_.REACT_APP_SH_PORTAL_BASENAME
                ? (window as any)._env_.REACT_APP_SH_PORTAL_BASENAME
                : '/'
            : '/',

    CUSTOMER_SUPPORT_LINK:
        process.env.NODE_ENV === 'production'
            ? (window as any)._env_.REACT_APP_CUSTOMER_SUPPORT_LINK
                ? (window as any)._env_.REACT_APP_CUSTOMER_SUPPORT_LINK
                : 'https://www.spoton.com/contact'
            : 'https://www.spoton.com/contact',

    PRIVACY_POLICY_LINK:
        process.env.NODE_ENV === 'production'
            ? (window as any)._env_.REACT_APP_PRIVACY_POLICY_LINK
                ? (window as any)._env_.REACT_APP_PRIVACY_POLICY_LINK
                : 'https://www.spoton.com/legal/privacy'
            : 'https://www.spoton.com/legal/privacy',

    // Merchant blacklist for disabling redemption messaging
    //  This should be a string containing comma separated HUB Id's
    DISABLED_REDEMPTION_MERCHANTS:
        process.env.NODE_ENV === 'production'
            ? (window as any)._env_.REACT_APP_DISABLED_REDEMPTION_MERCHANTS
            : process.env.REACT_APP_DISABLED_REDEMPTION_MERCHANTS,
};
